export enum EVINCED_SEVERITIES_UUIDS {
	CRITICAL = '3c68eb41-9227-481d-8eec-9dc8956b19c4',
	SERIOUS = '5bd03118-5883-4f43-8831-1544af3afe7c',
	MINOR = '4637208d-4f70-483d-b589-ff591c7130a0',
	MODERATE = 'b3916735-5371-4112-994e-f2fd909a42e1',
	BEST_PRACTICE = '778e3252-7359-4bd9-92d6-976d77e1dfd6',
	NEEDS_REVIEW = '3c68eb41-9227-481d-8eec-9dc8956b1900'
}
